module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_vm._v("Introduction: Before Korn: A Century of Jewish"), _c('br'), _vm._v("Historical Writing about the American Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Adam Mendelsohn")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/overview#overview"
    }
  }, [_vm._v("Overview: The War between Jewish Brothers in America")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Eli N. Evans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")]), _vm._v(" Jews and Slavery")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Jews and New Christians in the Atlantic Slave Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Seymour Drescher")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Jews and Negro Slavery in the Old South, 1789–1865")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Bertram W. Korn")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _vm._v(" Jews and Abolition")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Revolution and Reform:"), _c('br'), _vm._v("The Antebellum Jewish Abolitionists")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Jayme A. Sokolow")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Abolitionists and the Jews: Some Further Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Louis Ruchames")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART III")]), _vm._v(" Rabbis and the March to War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Isaac Mayer Wise and the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Sefton D. Temkin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Baltimore Rabbis during the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Isaac M. Fein")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART IV")]), _vm._v(" Jewish Soldiers during the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Divided Loyalties in 1861: The Decision of Major Alfred Mordecai")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Stanley L. Falk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Jewish Confederates")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Robert N. Rosen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 From Peddler to Regimental Commander in Two Years:"), _c('br'), _vm._v("The Civil War Career of Major Louis A. Gratz")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Jacob Rader Marcus")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART V")]), _vm._v(" The Home Front")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Eugenia Levy Phillips: The Civil War"), _c('br'), _vm._v("Experiences of a Southern Jewish Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("David T. Morgan")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Shifting Veils: Religion, Politics, and Womanhood in"), _c('br'), _vm._v("the Civil War Writings of American Jewish Women")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Dianne Ashton")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART VI")]), _vm._v(" Jews as a Class")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 “Shoddy” Antisemitism and the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Gary L. Bunker and John J. Appel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Jewish Chaplains during the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Bertram W. Korn")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 That Obnoxious Order")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("John Simon")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Civil War Exodus: The Jews and Grant’s General Order No. 11")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Stephen V. Ash")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART VII")]), _vm._v(" Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 The Post–Civil War Economy in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Thomas D. Clark")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Candidate Grant and the Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapaut"
  }, [_c('em', [_vm._v("Joakim Isaacs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap2a"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/furtherreading#furtherreading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap2"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap2"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/abouttheeditors#abouttheeditors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0